import ArticleToolbar from './ArticleToolbar';

const articleToolbarConfig = {
  name: 'articleToolbar',
  class: ArticleToolbar,
  querySelector: {
    progressBar: '.article-toolbar__progress-bar',
  },
  options: {
    // Headroom.js config
    // @ref: http://wicky.nillia.ms/headroom.js/
    headroom: {
      // vertical offset in px before element is first unpinned
      offset: 600,
      // scroll tolerance in px before state changes
      tolerance: 5,
      // css classes to apply
      classes: {
        // when element is initialised
        initial: 'article-toolbar',
        // when scrolling down
        pinned: 'article-toolbar--slidedown',
        // when scrolling up
        unpinned: 'article-toolbar--slideup',
        // when above offset
        top: 'article-toolbar--top',
        // when below offset
        notTop: 'article-toolbar--not-top',
        // when at bottom of scoll area
        bottom: 'article-toolbar--bottom',
        // when not at bottom of scroll area
        notBottom: 'article-toolbar--not-bottom',
      },
    },
  },
};

export default articleToolbarConfig;



// WEBPACK FOOTER //
// ./client/js/components/Header/articleToolbarConfig.js